import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cced1bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-trademarks" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas px-1" }, "search", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "search-results list-group list-group-flush position-absolute w-100 overflow-auto shadow border border-1 border-top-0 border-light rounded-bottom"
}
const _hoisted_6 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_7 = {
  key: 1,
  class: "list-group-item fst-italic"
}
const _hoisted_8 = {
  key: 2,
  class: "list-group-item fst-italic"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_SelectTrademarksSelected = _resolveComponent("SelectTrademarksSelected")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["search-wrapper position-relative mb-1", {open: this.searchQuery.length >= 2 }])
    }, [
      _createElementVNode("form", {
        class: "input-group",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (this.submitSearch && this.submitSearch(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.searchQuery) = $event)),
          type: "text",
          class: "form-control input-search-trademarks",
          name: "searchLabOrTrademark",
          placeholder: `${_ctx.$t('searchTrademark')}...`,
          autocomplete: "off",
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.submitSearch && this.submitSearch(...args)))
        }, null, 40, _hoisted_2), [
          [_vModelText, this.searchQuery]
        ]),
        (this.hasSearchQuery)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-search-reset-trademarks btn-close",
              type: "reset",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.clearSearch && this.clearSearch(...args)))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["btn-search-submit-trademarks", this.btnClass]),
          type: "submit"
        }, _hoisted_4, 2)
      ], 32),
      (this.searchQuery.length >= 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!this.isReadySearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_base_spinner)
                ]))
              : (this.exceptions.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(this.exceptions[0].message), 1))
                : (!this.hasSearchedTrademarks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('noTrademarksFound')), 1))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(this.searchedTrademarks, (searchedTrademark) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: searchedTrademark.code,
                        type: "button",
                        class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                        onClick: _withModifiers(($event: any) => (this.addTrademark(searchedTrademark.code)), ["prevent"])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(searchedTrademark.description), 1),
                        _hoisted_10
                      ], 8, _hoisted_9))
                    }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_SelectTrademarksSelected, {
      "selected-trademark-codes": this.selectedTrademarkCodes,
      "catalog-customer-code": this.catalogCustomerCode,
      "pim-trademarks": this.isPimTrademarks ? this.pimTrademarks : undefined,
      onRemoveTrademark: this.removeTrademark
    }, null, 8, ["selected-trademark-codes", "catalog-customer-code", "pim-trademarks", "onRemoveTrademark"])
  ]))
}